import React from 'react'
import {
    makeStyles,
    Box,
    IconButton,
    Link,
    Typography,
} from '@material-ui/core'
import Logo from "../images/logo/SugarCribs.svg";
import Logo_pink from "../images/logo/SugarCribs_pink.svg";
import Twitter from "../images/social/twitter.svg";
import Instagram from "../images/social/instagram.svg";
import PinkTwitter from "../images/social/pinkTwitter.svg";
import PinkInstagram from "../images/social/pinkInstagram.svg";
import { useIsCreatorsPage } from '../hooks/useIsCreatorsPage';

const useStyles = makeStyles((theme) => ({
    footer: {
        backgroundColor: '#1B1B1B',
        borderTop: '1px solid #1F1F1F',
        padding: "32px 70px",
        [theme.breakpoints.down('sm')]: {
            padding: "32px 21px",
        }
    },
    footerContent: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) repeat(auto-fit, 200px)',
        gap: "20px",
        marginBottom: "24px",
        [theme.breakpoints.down('md')]: {
            gridTemplateColumns: 'minmax(0, 1fr) repeat(3, 1fr)',
        },
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: 'minmax(0, 1fr) repeat(1, 1fr)',
        },
    },
    footerBrand: {
        maxWidth: 200,
        [theme.breakpoints.down('md')]: {
            gridColumn: "1 / -1",
            marginBottom: 12
        },
    },
    footerTagline: {
        fontSize: '16px',
        fontWeight: 300,
        lineHeight: 1.1,
        marginTop: "20px"
    },
    footerColumn: {},
    footerColumnTitle: {
        fontSize: '18px',
        fontWeight: 700,
        marginBottom: "20px",
    },
    footerLink: {
        display: 'block',
        color: '#FFFFFFCC',
        textDecoration: 'none',
        fontSize: '16px',
        marginBottom: "12px",
        lineHeight: 1.1,
        fontWeight: 400,
        transition: 'opacity 0.2s',
        '&:hover': {
            opacity: 0.8,
            textDecoration: 'none',
            color: '#FFFFFFCC',
        },
    },
    footerBottom: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: "24px",
        borderTop: '1px solid #1F1F1F',
        flexWrap: 'wrap',
        gap: 24
    },
    footerSocial: {
    },
    socialLabelText: {
        fontSize: '18px',
        fontWeight: 700,
        fontFamily: '"TT Norms Pro", serif',
        marginBottom: 20
    },
    socialLabel: {
        display: "flex",
        gap: 12
    },
    socialIcon: {
        color: '#ffffff',
        width: 24,
        height: 24,
        '&:hover': {
            opacity: 0.8,
        },
    },
    footerCopyright: {
        fontSize: '16px',
    },
    logo: {
        fontSize: '1.5rem',
        fontWeight: 500,
        color: '#ffffff',
        textDecoration: 'none',
    },
}))

export default function Footer() {
    const classes = useStyles()
    const isCreatorsPage = useIsCreatorsPage();

    const viewerFooterData = {
        Explore: [
            { title: "The Vault", href: "/the-vault" },
            { title: "Virtual Companionship", href: "#" },
            { title: "Lifestyle & Travel", href: "#" },
            { title: "Fine Art Glamour", href: "#" },
        ],
        Company: [
            { title: "About Us", href: "#" },
            { title: "Creator Application", href: "#" },
            { title: "Member Waitlist", href: "#" },
            { title: "Contact", href: "#" },
        ],
        Legal: [
            { title: "Terms of Service", href: "#" },
            { title: "Privacy Policy", href: "#" },
            { title: "DMCA", href: "#" },
            { title: "Compliance", href: "#" },
        ],
    };

    const creatorFooterData = {
        Resources: [
            { title: "Genesis Application", href: "#" },
            { title: "The Creator Blueprint", href: "#" },
            { title: "Monetization Guide", href: "#" },
        ],
        Support: [
            { title: "Help Center", href: "#" },
            { title: "Contact Dedicated Account Manager", href: "#" },
            { title: "Platform Status", href: "#" },
        ],
        Legal: [
            { title: "Creator Terms", href: "#" },
            { title: "Payout Schedule & Fees", href: "#" },
            { title: "Privacy Standards", href: "#" },
        ],
        "Creators hub": [
            { title: "Blog", href: "#" },
        ],
    };
    const footerData = isCreatorsPage ? creatorFooterData : viewerFooterData

    return (
        <Box component="footer" className={classes.footer}>
            <Box className={classes.footerContent}>
                <Box className={classes.footerBrand}>
                    <Link href="#" className={classes.logo}>
                        <img src={isCreatorsPage ? Logo_pink : Logo} alt="icon" width={176} height={40} />
                    </Link>
                    <Typography className={classes.footerTagline}>
                        The exclusive platform for premium connections.
                    </Typography>
                </Box>
                {Object.entries(footerData).map(([sectionTitle, links]) => (
                    <Box key={sectionTitle} className={classes.footerColumn}>
                        <Typography variant="h4" className={classes.footerColumnTitle}>
                            {sectionTitle}:
                        </Typography>
                        {links.map(link => (
                            <Link key={link.title} href={link.href} className={classes.footerLink}>
                                {link.title}
                            </Link>
                        ))}
                    </Box>
                ))}
            </Box>
            <Box className={classes.footerBottom}>
                <Box className={classes.footerSocial}>
                    <Typography variant="h4" className={classes.socialLabelText}>Follow Us:</Typography>
                    <Box className={classes.socialLabel}>
                        <IconButton className={classes.socialIcon} size="small">
                            <img src={isCreatorsPage ? PinkTwitter : Twitter} alt="icon" />
                        </IconButton>
                        <IconButton className={classes.socialIcon} size="small">
                            <img src={isCreatorsPage ? PinkInstagram : Instagram} alt="icon" />
                        </IconButton>
                    </Box>
                </Box>
                <Typography className={classes.footerCopyright}>
                    © {new Date().getFullYear()} SugarCribs. All rights reserved.
                </Typography>
            </Box>
        </Box>
    )
}
